import React from "react";

function Logo(props) {
  const {fill , fillRule , stroke , strokeWidth , width , height , viewBox} = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ||"36"}
      height={height || "36"}
      viewBox={viewBox || "0 0 36 36"}
    >
      <path
        fill={fill || "#FFF"}
        fillRule={fillRule || "evenodd"}
        stroke={stroke || "none"}
        strokeWidth={strokeWidth || "1"}
        d="M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18c0 3.665-1.095 7.073-2.976 9.917-.61.923 1.942 5.49 1.176 6.283-.915.948-5.178-1.907-6.281-1.177A17.916 17.916 0 0118 36zm0-7c6.075 0 11-4.925 11-11S24.075 7 18 7 7 11.925 7 18c0 2.24.67 4.323 1.819 6.06.373.564-1.187 3.355-.719 3.84.56.58 3.164-1.165 3.838-.72A10.949 10.949 0 0018 29z"
      ></path>
    </svg>
  );
}

export default Logo;